import request from '@/axios'
import { SystemMenuRespVO } from '@/api/admin/system/menu'

const splitPermissions = (permission: string) =>
  permission
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean)

export const getUserPermissionMenuApi = (
  menuTypes?: number[]
): Promise<IResponse<SystemMenuRespVO[]>> => {
  return request.get({
    url: '/admin/user/permission/menu',
    ...(menuTypes?.length ? { params: { menuTypes } } : {})
  })
}

// 重新实现 getUserAppCustomRouteApi 方法
export const getUserAppCustomRouteApi = async (
  strict = false
): Promise<AppCustomRouteRecordRaw[]> => {
  try {
    const menuListResp = await getUserPermissionMenuApi()
    // 后端无角色、无菜单及内置用户分支以 null 表示合法空权限。
    if (strict && menuListResp.data !== null && !Array.isArray(menuListResp.data)) {
      throw new Error('用户权限菜单响应无效')
    }
    const menuList = menuListResp.data || []

    // 构建菜单映射表
    const menuMap = new Map<string, SystemMenuRespVO>()
    menuList.forEach((menu) => menuMap.set(menu.code, menu))

    // 构建按钮权限映射表
    const buttonPermissionsMap = new Map<string, string[]>()
    menuList
      .filter((menu) => menu.type === 3)
      .forEach((button) => {
        if (button.parentCode) {
          if (!buttonPermissionsMap.has(button.parentCode)) {
            buttonPermissionsMap.set(button.parentCode, [])
          }
          buttonPermissionsMap.get(button.parentCode)?.push(...splitPermissions(button.permission))
        }
      })
    // 递归生成路由
    const generateRoutes = (parentCode: string): AppCustomRouteRecordRaw[] => {
      return menuList
        .filter((menu) => menu.parentCode === parentCode && (menu.type === 1 || menu.type === 2))
        .map((menu) => {
          const route: AppCustomRouteRecordRaw = {
            path: menu.path,
            name: menu.componentName || menu.name,
            component:
              menu.component && !['', '#'].includes(menu.component)
                ? `views/${menu.component}`
                : menu.component,
            meta: {
              title: menu.name,
              icon: menu.icon,
              hidden: !menu.visible,
              keepAlive: menu.keepAlive,
              permission: [
                ...(buttonPermissionsMap.get(menu.code) || []),
                ...splitPermissions(menu.permission)
              ]
            },
            children: generateRoutes(menu.code)
          }
          return route
        })
    }

    return generateRoutes('root')
  } catch (error) {
    if (strict) throw error
    console.error('获取用户权限菜单失败:', error)
    return []
  }
}
